mutation UserUploadDocument($document: DocumentUploadInput!) {
  userUploadDocument(document: $document) {
    uploadLink
    document {
      id
      _documentFileId
      _isAccountingDocument
    }
  }
}
